import React from "react";
import "./Contact.css";
const Contact = () => (
  <div className="contact" id="contact">
    <div className="footer-left">
      <h2>Achievements</h2>
      <h4>
        <li>Semi Finalist In TechGig Code Gladiators</li>
      </h4>
      <h4>
        <li>Top 3 Performer 2022 in GDSC CIT Chennai</li>{" "}
      </h4>
      <h4>
        <li>Semi Finalist In TechGig Geeks Goddess</li>{" "}
      </h4>
      <h4>
        <li>Got 3602 in Google Kickstart Round_H 2022</li>{" "}
      </h4>
      <h4>
        <li>5 Star in Python, C, C++, Problem Solving at HackerRank</li>{" "}
      </h4>
    </div>
    <div className="footer-right">
      <h3>I'm Interested About</h3>
      <div className="interests">
        <p>Frontend Development</p>
        <p>Backend Development</p>
        <p>Machine Learning</p>
        <p>Deep Learning</p>
        <p>AI Tools</p>
        <p>DevOps</p>
        <p>Generative AI</p>
        <p>OpenAI</p>
        <p>Large Language Model</p>
        <p>LangChain</p>
        <p>App Development</p>
        <p>UI / UX Design</p>
        <p>Amazon Web Services</p>
      </div>
      <hr />
      <h3>
        Wanna Hire Me ?
        <span>
          <a href="mailto:sriragavip@gmail.com"> Mail</a>
        </span>
      </h3>
    </div>
  </div>
);

export default Contact;
